import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const StyledButtonGroup = styled.div`
  [data-button-group] {
    ${borderRadius.r2};
    width: 300px;
  }
  [data-button-group-item] {
    padding: 4px 8px;
  }
`;

export const Title = styled.h2`
  ${typographyV2.titleMd}
  color: var(--text-default);
`;
